<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">续费</div>
    <div slot="body">
      <a-form :form="form.fc">
        <a-form-item label="续费时长" v-bind="formItemLayout">
          <duration :decorators="decorators.duration" :form="form" />
        </a-form-item>
      </a-form>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">续订</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import WorkflowMixin from '@/mixins/workflow'
import Duration from '@Compute/sections/Duration'

export default {
  name: 'RenewVmDialog',
  components: {
    Duration,
  },
  mixins: [DialogMixin, WindowsMixin, WorkflowMixin],
  data () {
    return {
      loading: false,
      form: {
        fc: this.$form.createForm(this),
        fd: {
          duration: '',
        },
      },
      decorators: {
        duration: {
          durationStandard: [
            'durationStandard',
            {
              initialValue: 'none',
            },
          ],
          duration: [
            'duration',
            {
              initialValue: '1m',
            },
          ],
        },
      },
      formItemLayout: {
        wrapperCol: {
          span: 19,
        },
        labelCol: {
          span: 5,
        },
      },
    }
  },
  computed: {
    ...mapGetters(['isAdminMode', 'userInfo']),
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        const id = this.params.id
        const formData = await this.form.fc.validateFields()
        const requestData = {
          duration: formData.duration ? formData.duration : formData.durationStandard,
        }
        console.info('renew request data:', requestData)
        const { data: res } = await this.$http({
          method: 'POST',
          url: `/sa/bill/api/v1/asset/${id}/renew`,
          data: requestData,
        })
        const { orderId } = res
        this.$router.push(`/llm/bill/bills/${orderId}/overview`)
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
